import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type GetAttendEventDetailPath =
  operations['AdminGroupEventController_getDetailGroupEvent']['parameters']['path'];
type GetAttendEventDetailHeaders =
  operations['AdminGroupEventController_getDetailGroupEvent']['parameters']['header'];

interface GetAttendEventDetailProps {
  path: GetAttendEventDetailPath;
  headers?: OmitGroupIdInHeader<GetAttendEventDetailHeaders>;
}

type GetAttendEventDetailResponse = components['schemas']['GroupEvent$cmi6Smk3SukQjEJ60RJvjg'];

export async function getAttendEventDetail({
  path,
  headers,
}: GetAttendEventDetailProps): Promise<GetAttendEventDetailResponse | false> {
  const response = await authenticateRequest<GetAttendEventDetailResponse>({
    method: 'get',
    url: `/api/v1/admin/group-event/${path.groupEventId}`,
    headers,
  });

  console.log('getAttendEventDetail', { response });
  return response;
}
